import React from "react";
// import { useTranslationContext } from "@providers/TranslationProvider";
import Header from "@components/Header";
import Footer from "@components/Footer";

// import Banner from "@components/Contact/Banner";
import Banner from "@components/Banner";
import GetInTouch from "@components/Contact/GetInTouch";
import OurHotel from "@components/Contact/OurHotel";
import { usePageContext } from "@providers/PageProvider";
import { contactPage } from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { pageData } = usePageContext();
  const banner = contactPage.formatBanner(pageData);
  return (
    <div className="contactPage" data-scroll-container>
      <Header />
      <Banner
        image={_.get(banner, "image")}
        scale={1.1}
        title={_.get(banner, "title", "")}
        description={_.get(banner, "description", "")}
      />
      <OurHotel />
      <GetInTouch />
      <Footer hideSocialIcons />
    </div>
  );
};

export default View;
